import { ParameterType } from '@/study-search/enums';
import { RouteParams } from 'vue-router';

import { AreaFilterDefinition, CountryFilterDefinition, PortalDefinition } from '../definition';
import { ParsedFilter } from '../generalizations/ParsedFilter';

class PathParser {
	public parse(params: RouteParams, portalDefinition: PortalDefinition): ParsedFilter[] {
		const filters: ParsedFilter[] = [];

		const validPathParts = this.getValidPathParts(params, portalDefinition);
		validPathParts.forEach((_) => filters.push(this.reconstituteFilterForPathPart(_, portalDefinition)));

		const countryFilter = this.getCountryFilterFromArea(validPathParts);
		if (countryFilter !== undefined) {
			filters.push(countryFilter);
		}

		return filters;
	}

	private getValidPathParts(params: RouteParams, portalDefinition: PortalDefinition): string[] {
		const pathParts = Object.values(params) as string[];
		return pathParts.filter((_) => _ !== '' && portalDefinition.exists(_.toLowerCase())).map((_) => _.toLowerCase());
	}

	private reconstituteFilterForPathPart(pathPart: string, portalDefinition: PortalDefinition): ParsedFilter {
		const filterDefinition = portalDefinition.filterDefinitions.filter((_) => _.exists(pathPart))[0];

		return new ParsedFilter(filterDefinition.type, [filterDefinition.getOptionValue(pathPart)]);
	}

	private getCountryFilterFromArea(pathParts: string[]): ParsedFilter | undefined {
		const countryFilterDefinition = new CountryFilterDefinition();
		const areaPath = pathParts.find((_) => AreaFilterDefinition.exists(_));
		const countryPath = pathParts.find((_) => countryFilterDefinition.exists(_));

		if (areaPath !== undefined && countryPath === undefined) {
			const countryId = AreaFilterDefinition.getCountryId(AreaFilterDefinition.getOptionValue(areaPath));

			return new ParsedFilter(ParameterType.COUNTRY, [countryId]);
		}
	}
}

export default new PathParser();
